import {italianDay} from './studioAgenda';
export function patientContacts(patient) {
 const raw=(patient.phone||'').trim();
 const phone=/^\+?[\d\s().-]+$/.test(raw)?raw.replace(/[\s().-]/g,'').replace(/^00/,'+'):'';
 const valid=/^\+?\d{6,15}$/.test(phone);
 const email=(patient.email||'').trim();
 return {call:valid?`tel:${phone}`:null,whatsapp:valid&&phone.startsWith('+')?`https://wa.me/${phone.slice(1)}`:null,
 email:/^[^\s@?&#]+@[^\s@?&#]+\.[^\s@?&#]+$/.test(email)?`mailto:${encodeURIComponent(email)}`:null};
}
export function lastClinicalContact(activity) {
 if(!activity)return null;
 return [activity.lastVisitAt,activity.lastMeasurementAt].filter(Boolean).sort((a,b)=>new Date(b)-new Date(a))[0]||null;
}
export function matchesPatientOperation(patient,activity,filter,now=new Date()) {
 if(filter==='all')return true;
 if(!activity)return false;
 if(filter==='drafts')return activity.draftPlans>0;
 if(filter==='open')return activity.openVisits>0;
 const last=lastClinicalContact(activity);
 if(filter==='never')return !last;
 if(!last)return false;
 const days=(Date.parse(italianDay(now))-Date.parse(italianDay(last)))/86400000;
 return days>=Number(filter);
}
